import { IS_LABRADOR_ID_FORMAT } from './regexp.js';

const allerNorwaySites = [
	'bergen.dagbladet.no',
	'borsen.dagbladet.no',
	'dagbladet.no',
	'dinside.dagbladet.no',
	'elbil24.no',
	'kk.no',
	'kode24.no',
	'lommelegen.dagbladet.no',
	'oppskrift.dagbladet.no',
	'plussmobil.no',
	'seher.no',
	'sol.no',
	'trondheim.dagbladet.no',
];
const allerNorwaySiteAliases = [
	'oppskrift.no',
	'dinside.no',
	'borsen.no',
	'lommelegen.no',
];

/**
 * this function only accepts url parsed hostnames stripped of www.
 * @param {string} strippedHost
 */
export function isInternalUrl(strippedHost) {
	return (
		allerNorwaySites.includes(strippedHost) ||
		allerNorwaySiteAliases.includes(strippedHost)
	);
}

/**
 * @param {string} path
 */
export function findLabradorId(path) {
	if (!path) return;
	const pathParts = path.split('/');
	if (!pathParts || !Array.isArray(pathParts)) return false;

	if (
		!pathParts.some((/** @type {string} */ part) =>
			IS_LABRADOR_ID_FORMAT.test(part),
		)
	)
		return;
	return pathParts.find((part) => IS_LABRADOR_ID_FORMAT.test(part));
}
